import React, { useEffect, useState } from 'react'

const JsonViewer = ({ data, isLink, classNames }) => {
  const [jsonData, setJsonData] = useState(null)

  useEffect(() => {
    if (isLink) {
      fetchJsonData()
    } else {
      try {
        const parsedData = typeof data === 'string' ? JSON.parse(data) : data
        setJsonData(parsedData)
      } catch (err) {
        setJsonData(null)
      }
    }
  }, [data, isLink])

  const fetchJsonData = async () => {
    try {
      const response = await fetch(data)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const json = await response.json()
      setJsonData(json)
    } catch (err) {
      setJsonData(null)
    }
  }

  return (
    <pre className={`text-sm text-left p-2.5 bg-[#f4f4f4] overflow-auto max-h-[80%] ${classNames}`}>
      {jsonData && JSON.stringify(jsonData, null, 2)}
    </pre>
  )
}

export default JsonViewer
